// C:\MonProjet\BBW_DELEGUER\preprod\babyworld-backoffice\babyworld-backoffice\src\components\layout\Header.js

import { useEffect } from "react";
import { Row, Col, Button, Divider } from "antd";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { LogoutOutlined, RocketOutlined, MenuOutlined } from "@ant-design/icons"; // <-- MenuOutlined ajouté
import { clearToken } from "../../redux/sign-in/signinSlice";

function Header({ name, subName, onPress }) { // <-- onPress récupéré ici
  const history = useHistory();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.signin.user);
  const isAdmin = user?.role?.id === 1;

  useEffect(() => window.scrollTo(0, 0));

  const handleLogout = () => {
    dispatch(clearToken());
    history.push("/sign-in");
    window.location.reload();
  };

  return (
    <>
      <Row gutter={[16, 0]} align="middle" style={{ width: '100%' }}>
        {/* BOUTON HAMBURGER POUR OUVRIR LE MENU À GAUCHE */}
        <Col xs={4} sm={4} md={4} lg={0} xl={0}>
          <Button
            type="text"
            className="sidebar-toggler"
            onClick={onPress}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '20px',
              padding: '4px 10px',
              color: '#0e519b', // Bleu Babyworld
              cursor: 'pointer',
            }}
          >
            <MenuOutlined style={{ fontSize: '22px' }} />
          </Button>
        </Col>

        {/* Espace flexible pour pousser les boutons de droite */}
        <Col flex="auto"></Col>
        
        {/* BOUTON : PLATEFORME CLINIQUE */}
        {isAdmin && (
          <Col>
            <Button 
              type="primary"
              icon={<RocketOutlined />} 
              onClick={() => history.push("/rapports-cliniques")}
              style={{ 
                display: 'flex', 
                alignItems: 'center', 
                fontWeight: 'bold',
                borderRadius: '8px', 
                backgroundColor: '#0e519b',
                borderColor: '#0e519b',
                boxShadow: '0 2px 5px rgba(14, 81, 155, 0.3)',
              }}
            >
              PLATEFORME CLINIQUE
            </Button>
          </Col>
        )}

        {isAdmin && <Col><Divider type="vertical" /></Col>}

        {/* BOUTON DÉCONNEXION */}
        <Col>
          <Button 
            type="text" 
            icon={<LogoutOutlined />} 
            onClick={handleLogout}
            style={{ 
              display: 'flex', 
              alignItems: 'center', 
              fontWeight: '500',
              fontSize: '14px',
              backgroundColor: 'white',
              border: '1px solid #ffccc7',
              borderRadius: '8px',
              padding: '5px 15px',
              height: 'auto',
              boxShadow: '0 2px 5px rgba(0,0,0,0.05)',
              color: '#e00718',
            }}
          >
            Se déconnecter
          </Button>
        </Col>
      </Row>
    </>
  );
}

export default Header;